import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (20.998 / 24);
  const localHeight = size * (19 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 20.998 19">
      <g transform="translate(-44.5 -57.5)">
        <path
          d="M1267,1180.51h20"
          transform="translate(-1222 -1121.51)"
          fill="none"
          stroke={localColor}
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          d="M1267,1180.51h20"
          transform="translate(-1222 -1113.51)"
          fill="none"
          stroke={localColor}
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          d="M1267,1180.51h20"
          transform="translate(-1222 -1105.51)"
          fill="none"
          stroke={localColor}
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          d="M1267,1180.51h4"
          transform="translate(-1221 -1121.51)"
          fill="none"
          stroke={localColor}
          strokeLinecap="round"
          strokeWidth="3"
        />
        <path
          d="M1267,1180.51h4"
          transform="translate(-1210 -1113.51)"
          fill="none"
          stroke={localColor}
          strokeLinecap="round"
          strokeWidth="3"
        />
        <path
          d="M1267,1180.51h4"
          transform="translate(-1218 -1105.51)"
          fill="none"
          stroke={localColor}
          strokeLinecap="round"
          strokeWidth="3"
        />
      </g>
    </svg>
  );
};

export default Index;
